import { Modal } from '@wix/vmaf-adi-components';

export default Modal;
